/* eslint-disable @repo/internal/react/require-jsdoc */

import React, { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack } from '@atlaskit/primitives/stack';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const styles = xcss({
	width: '100%',
	maxWidth: '1028px',
	paddingInline: 'space.150',
	'@media (min-width: 48rem)': {
		paddingInline: 'space.300',
	},
});

export const PageContentContainer = ({ children }: { children: ReactNode }): React.JSX.Element => {
	return (
		<Stack xcss={styles} space="space.300">
			{children}
		</Stack>
	);
};
